import * as yup from "yup";

export const ReactivatePartnerSchema = yup.object().shape({
  reasonReactivation: yup.string().required("La razón de reactivación es requerida"),
  reactivationDate: yup.string().required("La fecha de reactivación es requerida"),
});

